export class DatetimeLayout {

    constructor(layouts, layoutId, value) {
        this._layoutId = layoutId;
        this._value = value;
        this._layouts = layouts;
        this._layout = {};
        this._tag = "";
        this._datetime = "";

        this._run();
    }

    _run() {
        this._findLayoutByTag();
        this._leftZeroesPreventInValue();
        const h = this._extractInValueByPosition(this._layout.positions.h);
        const i = this._extractInValueByPosition(this._layout.positions.i);
        const s = this._extractInValueByPosition(this._layout.positions.s);
        const d = this._extractInValueByPosition(this._layout.positions.d);
        const m = this._extractInValueByPosition(this._layout.positions.m);
        const y = this._extractInValueByPosition(this._layout.positions.y);
        this._datetime = `${y}-${m}-${d} ${h}:${i}:${s}`;
    }

    _extractInValueByPosition(pos) {
        return this._value.toString().substr(pos[0], pos[1]);
    }

    _findLayoutByTag() {
        const layouts = this._layouts.filter((item) => item.id === this._layoutId);
        this._layout = layouts[0] ?? new Object();
    }

    _leftZeroesPreventInValue() {
        this._value = this._value.toString().padStart(this._getLenByLayout(), "0");
    }

    _getLenByLayout() {

        let len = 0;

        for (let i in this._layout.positions) {
            const layout = this._layout.positions[i];
            len += parseInt(layout[1]);
        }

        return len;
    }

    getDatetime() {
        return this._datetime;
    }
}